import api from "../../../api/api";

export const getInquiryReport = (page: number, params: any) => {
  return api.get("/crm/reports/inquiry-list/", {
    params: {
      page,
      ...params,
    },
  });
};

export const exportInquiryReport = (params: any) => {
    return api.get("/crm/reports/inquiry-list/", {
        params: {
            ...params,
            export: "csv",   // 👈 IMPORTANT
        },
        responseType: "blob",
    });
};

export const getNotAttended30DaysReport = (page: number, params: any) => {
  return api.get("/crm/reports/not-attended-30-days/", {
    params: {
      page,
      ...params,
    },
  });
};

export const exportNotAttended30DaysReport = (params: any) => {
  return api.get("/crm/reports/not-attended-30-days/", {
    params: {
      ...params,
      export: "csv",   // 👈 IMPORTANT
    },
    responseType: "blob",
  });
};

export const getContactDirectoryReport = (filters: any) => {
  return api.get(`/crm/reports/contact-directory-report/`, {
    params: {
      group_by: "source",
      from_date: filters.date_from,
      to_date: filters.date_to,
      source: filters.source || "",
      vertical: filters.vertical
    }
  });
};




export const exportContactDirectoryReport = (filters: any) => {
  return api.get("/crm/reports/contact-directory-report/", {
    params: {
      group_by: "source",
      from_date: filters.date_from,
      to_date: filters.date_to,
      source: filters.source || "",
      vertical: filters.vertical || "",
      export: "csv",   // ✅ IMPORTANT
    },
    responseType: "blob",  // ✅ IMPORTANT
  });
};

export const getAssignedToContactReport = (filters: any) => {
  return api.get("/crm/reports/contact-directory-report/", {
    params: {
      group_by: "assignee",   // ✅ CHANGE
      from_date: filters.date_from,
      to_date: filters.date_to,
      source: filters.source || "",
      vertical: filters.vertical || "",
      assigned_to: filters.assigned_to || "",   // ✅ NEW
    },
  });
};

export const getEmployeeContactReport = (filters: any) => {
  return api.get("/crm/reports/contact-directory-report/", {
    params: {
      group_by: "employee",   // ✅ CHANGE
      from_date: filters.date_from,
      to_date: filters.date_to,
      source: filters.source || "",
      vertical: filters.vertical || "",
      created_by: filters.created_by || "",   // ✅ NEW
    },
  });
};